export enum AppRouteParams {
  ContextOrganizationId = 'contextOrganizationId',
  ReportTab = 'reportTab',
  Date = 'date',
  AccountId = 'accountId',
}
